export default {
  Subs: {
    For: "اشتراک برای",
    PTM: "پلتفرم پزشکان «" + process.env.VUE_APP_INSTALL_NAME + "»",
    BySub: "با اشتراک",
    Free: "رایگان",
    CostDesc: "در <period> برای هر کاربر",
    month: "ماه",
    day: "روز",
    year: "سال",
    Connect: "اتصال",
    Connectv2: "فعال‌سازی اشتراک",
    CorpPlan: {
      desc: "شخصی",
      feature_1: "برنامه‌های شخصی‌سازی‌شده",
      feature_2: "پردازش تعداد انتخابی مطالعات در ماه با هر هوش مصنوعی",
      cost: "با درخواست",
      request: "ارسال درخواست",
      requested: "درخواست شما با موفقیت ارسال شد!",
      requested2:
        "ما به‌زودی با شما تماس خواهیم گرفت تا جزئیات را بررسی کنیم و راه‌حل مناسبی ارائه دهیم.  اگر سوالی دارید، <a target='_blank' class='demo__underline' href='https://t.me/thirdopinion_support_bot'>به ما پیام دهید!</a>",
    },
    yourSub: "اشتراک شما",
    PlansDesc: "توضیحات دقیق پلن‌ها",
    Offer: "پیشنهاد",
    EnterPromo: "کد تخفیف را وارد کنید",
    Errors: {
      NotPurchase: "اتصال اشتراک انجام نشد، لطفاً بعداً تلاش کنید",
    },
    DiffSubs: "تفاوت پلن‌ها",
    Plan: "پلن",
    Unavailable: "ابتدا باید لغو اشتراک کنید",
    extSub: "انتخاب پلن پیشرفته",
    lets: {
      modalTitle: {
        base: "لطفاً وارد کنید",
        and: " و ",
        phone: " شماره تلفن",
        email: "ایمیل",
      },
      text: "برای فعال‌سازی اشتراک باید <PHONE><EMAIL> خود را وارد کنید. این اطلاعات برای ارسال اعلان‌های مربوط به اشتراک و پیام‌های مهم دیگر استفاده خواهد شد.",
      formInvalid: "فرم به‌درستی پر نشده است",
    },
    cancelSub: "لغو",
    unsub: {
      title: "دسترسی شما به موارد زیر قطع خواهد شد:",
      modalTitle: "آیا مطمئن هستید که می‌خواهید اشتراک را لغو کنید؟",
      modalTitle2: "لطفاً دلیل لغو را انتخاب کنید",
      cancel: "اشتراک <NAME> تمدید شد. پرداخت بعدی در <DATE> انجام خواهد شد",
      yes: "لغو اشتراک",
      no: "نگه‌داشتن اشتراک",
      thx: {
        title: "متشکریم که با ما می‌مانید!",
        continue: "ادامه کار",
      },
      reasons: {
        0: "قیمت مناسب نیست",
        1: "از سرویس استفاده نمی‌کنم",
        2: "رابط کاربری نامناسب است",
        3: "سایر",
      },
      complete: {
        title: "شما اشتراک را لغو کردید",
        text1: "اشتراک شما تا ",
        text2:
          " فعال خواهد ماند و می‌توانید تا آن زمان از آن استفاده کنید. مشتاق دیدار دوباره شما هستیم!",
        recover: "بازیابی اشتراک",
      },
    },
    backToSite: "بازگشت به سایت",
    afterPay: {
      title: "اشتراک شما با موفقیت فعال شد!",
      text: "اکنون به قابلیت‌های پیشرفته سرویس دسترسی دارید!",
      buttonText: "شروع به کار",
    },
  },
};
